const src = import.meta.ROLLUP_FILE_URL_y3WuTrdTs_Si7uYpRddj9w;
export default {
  src,
  srcSet: src + " " + 1536 + "w",
  width: 1536,
  height: 1024,
};